const testimonials = [
  {
    name: "Stephanie R.",
    location: "Milton, GA",
    rating: 5,
    text: "My husband's business trip to Frankfurt was moved up with less than a week to spare. I called Fast Passport Center from our home in Milton on a Tuesday afternoon. They walked me through everything, we shipped overnight from Alpharetta, and he had his emergency passport by Friday. Absolutely amazing service.",
    service: "Emergency Passport",
  },
  {
    name: "David K.",
    location: "Alpharetta, GA",
    rating: 5,
    text: "We booked a family trip to Italy for spring break and realized my daughter's passport had expired three months ago. Fast Passport Center handled our expedited child passports with zero stress. They told us exactly which clerk to visit near Milton and had everything processed in under two weeks.",
    service: "Child Passport",
  },
  {
    name: "Lauren M.",
    location: "Roswell, GA",
    rating: 5,
    text: "As a consultant traveling internationally twice a month, I can't afford passport delays. When my renewal came up during a busy quarter, Fast Passport Center made the expedited passport renewal seamless. Shipped from Johns Creek, had it back in 5 business days.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MiltonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What North Fulton County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Milton, Alpharetta, Roswell, and North Fulton County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}